// Lightweight, privacy-friendly analytics wrapper around Plausible.
// No cookies, no personal data — just event names and a small set of props.
//
// The Plausible script is loaded from index.html. It exposes a global
// `window.plausible` function. If the script hasn't loaded yet (or is blocked),
// calls are queued onto `window.plausible.q` per Plausible's own pattern, so
// no events are lost and nothing throws.

type PlausibleProps = Record<string, string | number | boolean>;

type PlausibleFn = {
  (event: string, options?: { props?: PlausibleProps }): void;
  q?: unknown[];
};

declare global {
  interface Window {
    plausible?: PlausibleFn;
  }
}

export type AnalyticsEvent =
  | "explainer_started"
  | "explainer_completed"
  | "explainer_feedback"
  | "analogy_picked"
  | "toolkit_card_opened"
  | "toolkit_copy"
  | "toolkit_share"
  | "practice_started"
  | "practice_finished"
  | "waitlist_submitted"
  | "heritage_help_open"
  | "heritage_analyze_click"
  | "heritage_open_click";

export const track = (event: AnalyticsEvent, props?: PlausibleProps) => {
  if (typeof window === "undefined") return;
  try {
    const fn: PlausibleFn =
      window.plausible ||
      ((...args: unknown[]) => {
        (window.plausible!.q = window.plausible!.q || []).push(args);
      });
    if (!window.plausible) window.plausible = fn;
    fn(event, props ? { props } : undefined);
  } catch {
    /* analytics must never break the app */
  }
};
